import React from "react";
import "./BannerStyle/HeroContent.css";

const HeroContent = ({ slide }) => {
  
  const handleScroll = (e) => {
    e.preventDefault(); 
    const targetSection = document.getElementById("available-properties");
    
    if (targetSection) {
      targetSection.scrollIntoView({ 
        behavior: "smooth", 
        block: "start"      
      });
    }
  };

  return (
    <div className="gl-hero-section">
      <h2 className="hero-title">{slide.title}</h2>
      <p className="hero-description">{slide.des}</p>
      
      <a 
        href="#available-properties" 
        className="hero-button" 
        onClick={handleScroll}
      >
        Explore Now
      </a>
    </div>
  );
};

export default HeroContent;